<template>
  <div
    class="cost-bar d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between p-3 border-top bg-white"
  >
    <div
      class="cost-bar-info d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2 gap-sm-3 mb-2 mb-sm-0"
    >
      <div class="d-flex align-items-center gap-3 flex-wrap">
        <span class="fw-semibold">Current Cost:</span>
        <span
          class="cost-display fs-5 fw-bold"
          :class="overBudget ? 'text-danger' : ''"
          aria-live="polite"
          :aria-label="
            'Current cost ' +
            totalCost +
            ' dollars out of ' +
            budget +
            ' dollar budget'
          "
        >
          ${{ totalCost.toLocaleString() }} / ${{ budget.toLocaleString() }}
        </span>
        <span class="text-muted small">
          <i
            class="bi bi-check-circle-fill text-success me-1"
            aria-hidden="true"
          ></i
          >Autosaved
        </span>
      </div>

      <button class="btn back-link m-2" @click="$emit('back-to-prelab')">
        <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>Back to Pre-Lab
      </button>
    </div>

    <div class="d-flex align-items-stretch align-items-sm-center gap-2">
      <button
        class="btn btn-primary btn-lg px-4"
        @click="$emit('submit-design')"
        :disabled="totalCost === 0"
      >
        Submit Design for Verification
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CostBar",
  props: {
    totalCost: {
      type: Number,
      required: true
    },
    budget: {
      type: Number,
      required: true
    }
  },
  emits: ["submit-design", "back-to-prelab"],
  computed: {
    overBudget() {
      return this.totalCost > this.budget;
    }
  }
};
</script>

<style scoped>
.back-link {
  background-color: #495057;
  border: 1px solid #495057;
  color: #ffffff;
  padding: 0.375rem 0.75rem;
  text-decoration: none;
}

.back-link:hover,
.back-link:focus-visible {
  background-color: #343a40;
  border-color: #343a40;
  color: #ffffff;
  text-decoration: underline;
}

.back-link:focus-visible {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.35);
}
</style>
